import { Stack } from 'react-bootstrap';
import { ArrowLeftRight, ArrowRightCircleFill } from 'react-bootstrap-icons';
import React, { useEffect, useState } from 'react';

import { isRtl } from '../util/RtlLanguageUtil';
import { useStore } from '../store/store';
import LanguageDropdown from './LanguageSelector';

const TranslateSelection = () => {

	const { selectedSourceLocale, selectedTargetLocale, consumerLocales: languages, setIsTextAfterRtl, setIsTextBeforeRtl, setSelectedSourceLocale, setSelectedTargetLocale } = useStore((state) => state);

	const [swappable, setSwappable] = useState(false);
	const [languageFromLocaleId, setLanguageFromLocaleId] = useState<number | undefined>(undefined);
	const [languageToLocaleId, setLanguageToLocaleId] = useState<number | undefined>(undefined);

	/**
	 * Update Language Select Field based on language detected and update swappable state based on changes from languageFrom languageTo fields
	 */
	useEffect(() => {
		const hasSelectedFromLanguage = selectedSourceLocale !== undefined;
		const hasSelectedToLanguage = selectedSourceLocale !== undefined;
		const isLanguageSwappable =
			hasSelectedFromLanguage && hasSelectedToLanguage && selectedSourceLocale !== selectedTargetLocale;
		setSwappable(isLanguageSwappable);
	}, [selectedSourceLocale, selectedTargetLocale, swappable, languages]);

	useEffect(() => {
		if (selectedSourceLocale) {
			setLanguageFromLocaleId(selectedSourceLocale);
			setIsTextBeforeRtl(isRtl(selectedSourceLocale));
		}
		if (selectedTargetLocale) {
			setLanguageToLocaleId(selectedTargetLocale);
			setIsTextAfterRtl(isRtl(selectedTargetLocale));
		}
	}, [selectedSourceLocale, selectedTargetLocale]);

	const swapLanguages = () => {
		if (!selectedTargetLocale || !swappable) {
			return;
		}
		const from = selectedSourceLocale;
		const to = selectedTargetLocale;
		const fromLocaleId = languageFromLocaleId;
		const toLocaleId = languageToLocaleId;
		setSelectedSourceLocale(to);
		setSelectedTargetLocale(from!);
		setLanguageFromLocaleId(toLocaleId);
		setLanguageToLocaleId(fromLocaleId);
		setIsTextBeforeRtl(isRtl(toLocaleId));
		setIsTextAfterRtl(isRtl(fromLocaleId));
	};

	const onSwapLanguagesKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			swapLanguages();
		}
	}

	return (
		<Stack className="mt-2 gap-1 " direction="horizontal">

			<div className="lang-selector-wrapper">
				<div className="lang-selectors-container">
					<LanguageDropdown type="from" label="From:" />
					<div className="lang-arrow-container">
						<span
							tabIndex={swappable ? 0 : undefined}
							title={swappable ? 'Swap Languages' : 'Cannot Swap Languages'}
							className={"" + (swappable ? "pointer" : "")}
							onClick={swapLanguages}
							onKeyDown={onSwapLanguagesKeyDown}
							aria-label={ swappable ? "Swap Languages" : "Can not swap Languages" }
						>
							{
								swappable ? (
									<ArrowLeftRight
										className="mx-2 swap-lang-icon icon"
									/>
								) : (
									<ArrowRightCircleFill className="mx-2 swap-lang-icon icon"/>
								)
							}

						</span>
					</div>
					<LanguageDropdown type="into" label="Into:"/>
				</div>
			</div>
		</Stack>
	);
};
export default TranslateSelection;
